/**
 * 归一化仓库内路径。
 *
 * 设计说明：后端文件路径以仓库根为基准。前端提交前统一去掉前导斜杠，
 * 避免同一文件因为 `/foo` 和 `foo` 形成两个不同提交身份。
 *
 * @param fileId 原始文件路径或 FileInfo.fileId。
 * @returns 可用于版本提交接口的相对路径。
 */
export function normalizeRepositoryPath(fileId: string): string {
  return fileId.trim().replace(/^\/+/u, '');
}

